const APP_PAGE_TITLES = {
  BLOCK: 'Drift | Reusable blocks',
  SCENARIO: 'Drift | Scenarios',
  PLAYBOOK: 'Drift | Playbooks',
  FASTLANE: 'Drift | Fastlane',
  GUARDRAIL: 'Drift | Guardrails',
} as const

export { APP_PAGE_TITLES }
